import React from "react";
import $ from "$";
import { Input } from "antd";
import WeaBrowserSingle from "../base/wea-browser-single";
import WeaBrowserMuti from "../base/wea-browser-muti";
import classNames from "classnames";
import WeaCityPicker from "../wea-city-picker";
import WeaBrowserCheckbox from "../base/wea-browser-checkbox";
import WeaBrowserCheckboxSap from "../base/wea-browser-checkbox/sap";
import WeaTools from "../wea-tools";
import WeaSelect from "../wea-select";
import WeaHrmCondition from "../base/wea-hrm-condition";
import isEmpty from "lodash/isEmpty";
import uniq from "lodash/uniq";
import isEqual from "lodash/isEqual";
import WeaBrowserThumbnail from "../base/wea-browser-thumbnail";
import WeaBrowserHrm from "../base/wea-browser-hrm";
import WeaBrowserHrmMult from "../base/wea-browser-hrm-mult";
import WeaBrowserIcons from "../base/wea-browser-icons";
import WeaNodeTreeList from "../base/wea-node-tree-list";
import WeaBrowserOdocMuti from "../base/wea-browser-odoc-muti";

import WeaAssociativeSearchMult from "../base/wea-associative-search-mult";
import WeaAssociativeSearch from "../base/wea-associative-search";
import { getValueWarp, getPageSize } from "./coms/util";
import WeaSystempage from "./coms/WeaSystempage";
import WeaTypeList from "./coms/WeaTypeList";
import WeaDevModules from "../base/wea-dev-modules";
import WeaLocaleProvider from "../wea-locale-provider";
// import WeaBrowserTest from "../wea-browser-test/browser/index";
import WeaBrowserTest from "../wea-browser-test/index";
import { useTest } from "../wea-browser-test/isUseTest";
import { getKeys } from "../wea-browser-test/components/WeaBrowserTree";
import WindowFunc from "../wea-tools/window";
import middleware from "../../middleware";

import "./style/index.less";

import loadjs from "loadjs";

const getLabel = WeaLocaleProvider.getLabel;
const getHash = () =>
  Math.random()
    .toString(36)
    .substr(2, 6);

class Main extends React.Component {
  static WeaAssociativeSearchMult = WeaAssociativeSearchMult;
  static WeaAssociativeSearch = WeaAssociativeSearch;
  static urlOfIframeInDialogCallBack = {};
  static getKeys = getKeys;

  static defaultProps = {
    hideOps: false, // 是否隐藏放大镜
    showCheckStrictly: true, // 显示控制checkStrictly属性的按钮
    noOperate: true, // 浏览按钮table是否显示操作列， 默认不显示
    topPrefix: "wea",
    isLoadAll: false,
    hasRadio: false, // 流程导入按钮 true
    type: "7", // 字段的类型，对应workflow_billfield表中的type字段
    fieldName: "", // 浏览按钮的名称，在表单中是字段的ID
    viewAttr: 2, // 显示属性 1(只读)/2(可编辑)/3(必填)
    isSingle: true, // 是否单选; true:单选 false:多选
    title: getLabel(24986, "标题"), // 浏览框标题
    desc: "", // 浏览按钮的中文描述
    icon: "icon-toolbar-Organization-list", // 浏览框标题图标类名
    iconBgcolor: "#4A90E2", // 浏览框标题图标颜色
    onChange: "", // 回调函数
    linkUrl: "", // 浏览按钮显示值对应的链接地址
    inputStyle: {}, // 输入框的样式 宽度等
    modalStyle: { width: 784 }, // 浏览框样式
    isDetail: "", // 字段类型，主表字段最小宽度为230px，明细字段最小宽度为120px
    dataParams: {}, // dataURL默认参数
    conditionDataParams: {}, // 条件接口默认参数
    completeParams: {}, // completeURL默认参数
    isAutoComplete: 0, // 是否自动提示 默认值:否;
    hasAdd: false, // 是否显示快捷添加的按钮，true：显示 false：不显示
    ddUrl: "", // 添加按钮对应的链接地址
    addOnClick: "", // 单击添加按钮时触发的onclick事件
    hasScroll: true, // 输入框默认显示美化滚动条
    memorise: false, // customized 为true，默认不记忆右侧的选中数据
    scrollx: false, // 单选浏览 table 是否显示横向滚动条
    sortOrderAsc: true // 多人力浏览按钮自定义人员展示顺序排序方式，默认升序
  };
  constructor(props) {
    super(props);
    this.searchAdFormCallbackKey = getHash();
    // console.log('wea-browser->props',props.tabs);
    this.state = {
      selectOptions: []
    };
    this.useTest = useTest.bind(this);
    this.urlOfIframeInDialogKey = getHash();
    this.checkUrlOfIframeInDialogCallBackFunction();
  }
  checkUrlOfIframeInDialogCallBackFunction = () => {
    const { onChange } = this.props;
    const win = WindowFunc.getTop().ecCom ? WindowFunc.getTop() : window;

    if (
      win.ecCom &&
      this.urlOfIframeInDialogKey &&
      !win.ecCom.WeaBrowser.urlOfIframeInDialogCallBack[
        this.urlOfIframeInDialogKey
      ]
    ) {
      win.ecCom.WeaBrowser.urlOfIframeInDialogCallBack[
        this.urlOfIframeInDialogKey
      ] = data => {
        if (Array.isArray(data)) {
          const result = data.filter(item => item && item.id);
          this.set(result);
          if (typeof onChange === "function") {
            onChange(
              `${result.map(r => r.id)}`,
              `${result.map(r => r.name)}`,
              result
            );
          }
        }
        return this;
      };
    }
  };
  setMinWidth() {
    if (this.props.resize && this.refs.weaBrowser) {
      let dom = $(this.refs.weaBrowser);
      const browserWidth = 210;
      const interval = setInterval(() => {
        let width = dom.parent().outerWidth();
        if (width > 0) {
          if (width < 112) width = 112;
          dom.css("max-width", width);
          // 明细表单特殊处理
          let minWidth = browserWidth;
          if (width < browserWidth) {
            minWidth = width;
          }
          if (this.props.isDetail == 1) minWidth = width;
          dom
            .find(".wea-associative-search")
            .filter(":not(.wea-field-readonly)")
            .css("min-width", minWidth - 32)
            .css("margin-right", 12);
          dom.css("visibility", "visible");
          dom = null;
          clearInterval(interval);
        }
      }, 10);
    }
  }
  componentDidMount() {
    if (!this.useTest()) {
      if (this.props.type == "34") {
        this.getLevelCmpsDatas();
      }
      const customBrowser = ["161", "162", "256", "257"];
      if (customBrowser.indexOf(`${this.props.type}`) > -1) {
        loadjs.isDefined("customBrowserCss")
          ? ""
          : loadjs("/formmode/e9resource/css/iconapp.css", "customBrowserCss");
      }
      this.setMinWidth();
    }
    this.setMinWidth();
    this.checkUrlOfIframeInDialogCallBackFunction();
  }

  componentWillReceiveProps(nextProps) {
    if (!this.useTest()) {
      if (
        this.props.dataParams !== nextProps.dataParams &&
        this.props.type == "34"
      ) {
        this.getLevelCmpsDatas(nextProps.dataParams);
      }
      if (
        "value" in nextProps &&
        isEmpty(nextProps.value) &&
        nextProps.simpleRO
      ) {
        !nextProps.isSingle &&
          this.refs.associativeSearch &&
          this.refs.associativeSearch.clear();
        nextProps.isSingle &&
          this.refs.associativeSearch &&
          this.refs.associativeSearch.forceClear();
      }
      if (
        "replaceDatas" in nextProps &&
        !isEqual(this.props.replaceDatas, nextProps.replaceDatas) &&
        !nextProps.replaceNotCtrl &&
        nextProps.simpleRO
      ) {
        if (isEmpty(nextProps.replaceDatas)) {
          !nextProps.isSingle &&
            this.refs.associativeSearch &&
            this.refs.associativeSearch.clear();
          nextProps.isSingle &&
            this.refs.associativeSearch &&
            this.refs.associativeSearch.forceClear();
        }
      }
    }
  }

  componentDidUpdate() {
    this.setMinWidth();
    this.checkUrlOfIframeInDialogCallBackFunction();
  }
  componentWillUnmount() {
    const { urlOfIframeInDialog } = this.props;
    const win = WindowFunc.getTop().ecCom ? WindowFunc.getTop() : window;
    if (
      urlOfIframeInDialog &&
      win.ecCom &&
      win.ecCom.WeaBrowser.urlOfIframeInDialogCallBack[urlOfIframeInDialog]
    ) {
      win.ecCom.WeaBrowser.urlOfIframeInDialogCallBack[
        urlOfIframeInDialog
      ] = undefined;
    }
  }

  componentWillUnmount() {
    const win = WindowFunc.getTop().ecCom ? WindowFunc.getTop() : window;
    if (
      win.ecCom &&
      win.ecCom.WeaBrowser.urlOfIframeInDialogCallBack[
        this.urlOfIframeInDialogKey
      ]
    ) {
      win.ecCom.WeaBrowser.urlOfIframeInDialogCallBack[
        this.urlOfIframeInDialogKey
      ] = undefined;
    }
  }
  renderSingle() {
    const {
      type,
      dataParams,
      completeParams,
      conditionDataParams
    } = this.props;
    let { dataURL, conditionURL, completeURL, pageSize } = this.props;
    dataURL = dataURL || `/api/public/browser/data/${type}`;
    conditionURL = conditionURL || `/api/public/browser/condition/${type}`;
    completeURL = completeURL || `/api/public/browser/complete/${type}`;
    pageSize = pageSize > 0 ? pageSize : getPageSize(this.props);
    if (type == "browserTypeList") {
      return (
        <WeaTypeList
          initFunc={browser => (this.browser = browser)}
          dataURL={`${dataURL}?${WeaTools.getFd(dataParams)}`}
          completeURL={`${completeURL}?${WeaTools.getFd(completeParams)}`}
          {...this.props}
          pageSize={pageSize}
        />
      );
    }

    if (type == "icons") {
      return (
        <WeaBrowserIcons
          initFunc={browser => (this.browser = browser)}
          contentHeight={460}
          {...this.props}
          pageSize={pageSize}
        />
      );
    }
    if (type == "1") {
      return (
        <WeaBrowserHrm
          initFunc={browser => (this.browser = browser)}
          dropMenuIcon={<i className="icon-toolbar-Organization-list" />}
          virtualUrl="/api/public/browser/data/1?cmd=companyvirtual" // 维度
          resourcetree={`/api/public/browser/data/1?cmd=v2resourcetree&${WeaTools.getFd(
            dataParams
          )}`} // 按照组织结构
          grouptree={`/api/public/browser/data/1?cmd=v2grouptree&${WeaTools.getFd(
            dataParams
          )}`}
          conditionURL={`${conditionURL}?${WeaTools.getFd(
            conditionDataParams
          )}`}
          completeURL={`${completeURL}?${WeaTools.getFd(completeParams)}`}
          {...this.props}
          pageSize={pageSize}
          type={1}
          icon="icon-portal-hrm"
          iconBgcolor="#008572"
        />
      );
    }
    if (type == "258" || type == "2222" || type == "58" || type == "263") {
      // 国家 省份 城市 区县
      return (
        <WeaCityPicker
          initFunc={browser => (this.browser = browser)}
          dataUrl={`${dataURL}?${WeaTools.getFd(dataParams)}`} // 浏览框数据URL
          completeURL={`${completeURL}?${WeaTools.getFd(completeParams)}`} // 联想搜索URL
          conditionURL={`${conditionURL}?${WeaTools.getFd(
            conditionDataParams
          )}`} //浏览框高级查询条件URL
          {...this.props}
          pageSize={pageSize}
        />
      );
    }
    if (type == "nodeTreeList") {
      return (
        <WeaNodeTreeList
          initFunc={browser => (this.browser = browser)}
          // dataUrl={`${dataURL}?${WeaTools.getFd(dataParams)}`} //浏览框数据URL
          contentHeight={460} //浏览框内容高度
          {...this.props}
          pageSize={pageSize}
        />
      );
    }
    return (
      <WeaBrowserSingle
        initFunc={browser => (this.browser = browser)}
        dataUrl={`${dataURL}?${WeaTools.getFd(dataParams)}`} //浏览框数据URL
        completeURL={`${completeURL}?${WeaTools.getFd(completeParams)}`} //联想搜索URL
        conditionURL={`${conditionURL}?${WeaTools.getFd(conditionDataParams)}`} //浏览框高级查询条件URL
        contentHeight={460} //浏览框内容高度
        {...this.props}
        pageSize={pageSize}
        urlOfIframeInDialogKey={this.urlOfIframeInDialogKey}
      />
    );
  }
  renderMult() {
    const {
      type,
      dataParams,
      completeParams,
      conditionDataParams,
      destDataParams,
      isMultCheckbox
    } = this.props;
    let { dataURL, conditionURL, completeURL, pageSize } = this.props;
    const { props } = this;
    dataURL = dataURL || `/api/public/browser/data/${type}`;
    conditionURL = conditionURL || `/api/public/browser/condition/${type}`;
    completeURL = completeURL || `/api/public/browser/complete/${type}`;
    pageSize = pageSize > 0 ? pageSize : getPageSize(this.props);
    const valueWarp = getValueWarp(this.props);
    const otherProps = {
      valueWarp
    };
    if (type == "systempage") {
      // 门户
      return (
        <WeaSystempage
          initFunc={browser => (this.browser = browser)}
          dataURL={dataURL}
          completeURL={`${completeURL}?${WeaTools.getFd(completeParams)}`}
          contentHeight={460}
          {...this.props}
          pageSize={pageSize}
          {...otherProps}
        />
      );
    }
    if (type == "17") {
      return (
        <WeaBrowserHrmMult
          initFunc={browser => (this.browser = browser)}
          dropMenuIcon={<i className="icon-toolbar-Organization-list" />}
          virtualUrl="/api/public/browser/data/1?cmd=companyvirtual" // 维度
          resourcetree={`/api/public/browser/data/1?cmd=v2resourcetree&${WeaTools.getFd(
            dataParams
          )}`} // 按照组织结构
          grouptree={`/api/public/browser/data/1?cmd=v2grouptree&${WeaTools.getFd(
            dataParams
          )}`}
          completeURL={`${completeURL}?${WeaTools.getFd(completeParams)}`}
          conditionURL={`${conditionURL}?${WeaTools.getFd(
            conditionDataParams
          )}`}
          {...this.props}
          pageSize={pageSize}
          {...otherProps}
          type={17}
          icon="icon-portal-hrm"
          iconBgcolor="#008572"
        />
      );
    }
    if (type == "141") {
      // 人力资源条件 多选
      return (
        <WeaHrmCondition
          contentHeight={460}
          {...this.props}
          pageSize={pageSize}
          {...otherProps}
          conditionURL={`${conditionURL}?${WeaTools.getFd(
            conditionDataParams
          )}`} // 浏览框高级查询条件URL
        />
      );
    }
    if (isMultCheckbox) {
      if (props.sap) {
        return (
          <WeaBrowserCheckboxSap
            initFunc={browser => (this.browser = browser)}
            dataUrl={`${dataURL}?${WeaTools.getFd(dataParams)}`} // 浏览框数据URL
            completeURL={`${completeURL}?${WeaTools.getFd(completeParams)}`} // 联想搜索URL
            conditionURL={`${conditionURL}?${WeaTools.getFd(
              conditionDataParams
            )}`} // 浏览框高级查询条件URL
            destUrl={`/api/public/browser/destData/${type}?${WeaTools.getFd(
              destDataParams
            )}`}
            contentHeight={460} //浏览框内容高度
            {...this.props}
            pageSize={pageSize}
            {...otherProps}
            urlOfIframeInDialogKey={this.urlOfIframeInDialogKey}
          />
        );
      }
      return (
        <WeaBrowserCheckbox
          initFunc={browser => (this.browser = browser)}
          dataUrl={`${dataURL}?${WeaTools.getFd(dataParams)}`} // 浏览框数据URL
          completeURL={`${completeURL}?${WeaTools.getFd(completeParams)}`} // 联想搜索URL
          conditionURL={`${conditionURL}?${WeaTools.getFd(
            conditionDataParams
          )}`} // 浏览框高级查询条件URL
          destUrl={`/api/public/browser/destData/${type}?${WeaTools.getFd(
            destDataParams
          )}`}
          contentHeight={460} //浏览框内容高度
          {...this.props}
          pageSize={pageSize}
          {...otherProps}
          urlOfIframeInDialogKey={this.urlOfIframeInDialogKey}
        />
      );
    }
    if (type == "184") {
      return (
        <WeaBrowserThumbnail
          dataUrl={`${dataURL}?${WeaTools.getFd(dataParams)}`} // 浏览框数据URL
          completeURL={`${completeURL}?${WeaTools.getFd(completeParams)}`} // 联想搜索URL
          conditionURL={`${conditionURL}?${WeaTools.getFd(
            conditionDataParams
          )}`} // 浏览框高级查询条件URL
          destUrl={`/api/public/browser/destData/${type}?${WeaTools.getFd(
            destDataParams
          )}`} // 多选右侧查找数据接口
          contentHeight={450} //浏览框内容高度
          {...this.props}
          pageSize={pageSize}
          {...otherProps}
        />
      );
    }
    if (type == "devmodules") {
      return (
        <WeaDevModules
          initFunc={browser => (this.browser = browser)}
          contentHeight={410} //浏览框内容高度
          {...this.props}
          pageSize={pageSize}
        />
      );
    }
    if (type == "142") {
      return (
        <WeaBrowserOdocMuti
          initFunc={browser => (this.browser = browser)}
          dataUrl={`/api/public/browser/data/${type}`} // 浏览框数据URL
          completeURL={`/api/public/browser/complete/${type}?${WeaTools.getFd(
            completeParams
          )}`} // 联想搜索URL
          conditionURL={`/api/public/browser/condition/${type}?${WeaTools.getFd(
            conditionDataParams
          )}&`} // 浏览框高级查询条件URL
          destUrl={`/api/public/browser/destData/${type}?${WeaTools.getFd(
            destDataParams
          )}`} // 多选右侧查找数据接口
          contentHeight={410} //浏览框内容高度
          {...this.props}
          pageSize={pageSize}
          {...otherProps}
        />
      );
    }
    return (
      <WeaBrowserMuti
        initFunc={browser => (this.browser = browser)}
        dataUrl={`${dataURL}?${WeaTools.getFd(dataParams)}`} // 浏览框数据URL
        completeURL={`${completeURL}?${WeaTools.getFd(completeParams)}`} // 联想搜索URL
        conditionURL={`${conditionURL}?${WeaTools.getFd(conditionDataParams)}`} // 浏览框高级查询条件URL
        destUrl={`/api/public/browser/destData/${type}?${WeaTools.getFd(
          destDataParams
        )}`} // 多选右侧查找数据接口
        contentHeight={410} //浏览框内容高度
        {...this.props}
        pageSize={pageSize}
        {...otherProps}
        urlOfIframeInDialogKey={this.urlOfIframeInDialogKey}
      />
    );
  }
  renderInput() {
    // readOnly ? this.renderInput() :
    const { fieldName, value } = this.props;
    return <Input id={`${fieldName}span`} value={value} disabled />;
  }
  renderLevelCmps() {
    const { selectOptions } = this.state;
    return (
      <div
        style={{ display: "inline-block", width: "100%" }}
        ref="selectWrapper"
      >
        {!isEmpty(selectOptions) && (
          <WeaSelect
            {...this.props}
            // layout={this.refs.selectWrapper}
            detailtype={1}
            options={selectOptions}
            style={
              isEmpty(this.props.inputStyle)
                ? { width: 210 }
                : this.props.inputStyle
            }
          />
        )}
      </div>
    );
  }
  getLevelCmpsDatas(newParams = "") {
    let { dataURL } = this.props;
    const { dataParams, type } = this.props;
    dataURL = dataURL || `/api/public/browser/data/${type}`;
    dataURL = `${dataURL}?${WeaTools.getFd(newParams || dataParams)}`;
    WeaTools.callApi(dataURL)
      .then(data => {
        this.setState({ selectOptions: data.datas });
      })
      .catch(e => this.props.onError && this.props.onError(e));
  }
  focus() {
    this.browser && this.browser.focus && this.browser.focus();
  }
  set(datas) {
    this.browser && this.browser.set && this.browser.set(datas);
  }
  openModal() {
    this.browser && this.browser.openModal && this.browser.openModal();
  }
  closeModal() {
    this.browser && this.browser.closeModal && this.browser.closeModal();
  }
  get() {
    return this.browser && this.browser.get && this.browser.get();
  }
  reload() {
    this.browser && this.browser.reload && this.browser.reload();
  }
  render() {
    if (this.useTest()) {
      return (
        <WeaBrowserTest
          initFunc={browser => (this.browser = browser)}
          {...this.props}
          searchAdFormCallbackKey={this.searchAdFormCallbackKey}
        />
      );
    }
    const { customized, fieldName, viewAttr } = this.props;
    const valueWarp = getValueWarp(this.props);
    const className = classNames({
      "wea-browser": true,
      customized,
      "wea-field": /^field/.test(fieldName),
      "wea-field-readonly": viewAttr == "1"
    });
    const { isSingle, type } = this.props;
    // 请假类型
    if (type == "34") {
      return this.renderLevelCmps();
    }
    const style = {};
    if (this.props.resize) {
      style.visibility = "hidden";
    }

    if (viewAttr == "1" && this.props.simpleRO && type != "141") {
      let inputArr = (
        <WeaAssociativeSearch
          {...this.props}
          ref="associativeSearch"
          style={this.props.inputStyle}
          value={this.props.value}
          ids={
            (this.props.replaceDatas &&
              this.props.replaceDatas.length > 0 &&
              this.props.replaceDatas[0].id) ||
            this.props.value ||
            ""
          }
          names={
            (this.props.replaceDatas &&
              this.props.replaceDatas.length > 0 &&
              this.props.replaceDatas[0].name) ||
            (this.props.replaceDatas &&
              this.props.replaceDatas.length > 0 &&
              this.props.replaceDatas[0].lastname) ||
            this.props.valueSpan ||
            ""
          }
          // clickCallback={this.onBrowerClick}
          // onChange={this.onBrowerChangeHandler}
          hasScroll={!(this.props.noScroll || false)}
        />
      );
      let inputHidden = (
        <input
          type="hidden"
          id={this.props.fieldName}
          name={this.props.fieldName}
          value={
            this.props.value ||
            (this.props.replaceDatas &&
              this.props.replaceDatas.length > 0 &&
              this.props.replaceDatas[0].id) ||
            ""
          }
        />
      );
      if (!isSingle) {
        const searchKeys = [];
        const selectedData = {};
        const selectTypes = [];
        const datas = this.props.valueObj || this.props.replaceDatas;
        datas.forEach(item => {
          if (item) {
            searchKeys.push(item.id);
            selectTypes.push(item.type);
            selectedData[item.id] = item;
          }
        });
        const ids = uniq(searchKeys).join(",");

        inputHidden = (
          <input
            type="hidden"
            id={this.props.fieldName}
            name={this.props.fieldName}
            value={ids}
          />
        );

        inputArr = (
          <WeaAssociativeSearchMult
            {...this.props}
            valueWarp={valueWarp}
            ref="associativeSearch"
            // inputName={inputName}
            // inputId={inputId}
            style={this.props.inputStyle}
            datas={selectedData}
            selectedValues={searchKeys}
            selectTypes={selectTypes}
            allDatas={datas}
            type={this.props.type}
            // clickCallback={this.onBrowerClick}
            // onChange={this.onBrowerChangeHandler.bind(this)}
          />
        );
      }
      return (
        <div
          className={`${className} ${this.props.className || ""}`}
          style={style}
          ref="weaBrowser"
        >
          <div>
            {inputArr}
            {this.props.extraElement}
            {inputHidden}
          </div>
        </div>
      );
    }

    const browser = isSingle ? this.renderSingle() : this.renderMult();
    return (
      <div
        className={`${className} ${this.props.className || ""}`}
        style={style}
        ref="weaBrowser"
      >
        {browser}
      </div>
    );
  }
}

const Com = middleware(Main, "WeaBrowser");

export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-browser/index.js